export const DEFAULT_FIELDS = [
  'date', 'owner', 'contact_number', 'property_name', 'address', 'age', 'room_details',
];
export const SYSTEM_TOKENS = ['room_details', 'logo', 'seal'];

export const COMPANY_TEXT =
  'Your Company Pvt. Ltd. | Registered address | +91 00000 00000 | partners@example.com';

const svg = (label, w, h) =>
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}"><rect width="${w}" height="${h}" fill="#e8eefc" stroke="#7a8fd6"/><text x="${w / 2}" y="${h / 2 + 5}" font-size="14" text-anchor="middle" fill="#3b4f9a" font-family="Arial">${label}</text></svg>`
  );
// Replace the seal placeholder with your own local image if needed.
export const LOGO_IMAGE = svg('LOGO', 160, 48);
export const SEAL_IMAGE = svg('SEAL', 120, 120);

export const SAMPLE_VALUES = {
  date: '12 October 2026',
  owner: 'Ravi Kumar',
  contact_number: '+91 98765 43210',
  property_name: 'Sea View Residency',
  address: '12, Beach Road, Chennai, Tamil Nadu',
  age: '18Y+ 6month',
};
export const SAMPLE_ROOM_ROWS = [
  ['Deluxe', '10', 'Rs. 3,500'],
  ['Suite', '4', 'Rs. 6,000'],
];
export const SAMPLE_ROOM_TABLE_HTML =
  '<table><tbody><tr><th>Category</th><th>Rooms</th><th>Rate</th></tr>' +
  SAMPLE_ROOM_ROWS.map((r) => `<tr>${r.map((c) => `<td>${c}</td>`).join('')}</tr>`).join('') +
  '</tbody></table>';

export const A4_HEIGHT_PX = (297 * 96) / 25.4;

// The ONLY source of the <style> block written into saved HTML (no CSS variables, no @font-face).
export const DOC_STYLE = `
@page { size: A4; margin: 0; }
html, body { margin: 0; width: 210mm; }
body { font-family: 'Open Sans', Arial, sans-serif; font-size: 12pt; line-height: 1.325; color: #111; }
.page { box-sizing: border-box; overflow-wrap: anywhere; width: 210mm; min-height: 296.5mm; padding: 54mm 25mm 6mm 25mm;
  background: url("{{logo}}") no-repeat 2.5mm -3.2mm / 205.3mm 54.3mm, #fff;
  -webkit-print-color-adjust: exact; print-color-adjust: exact;
  -webkit-box-decoration-break: clone; box-decoration-break: clone; break-after: page; }
.page:last-of-type { break-after: auto; }
h1 { font-size: 20pt; margin: 0; }
h2 { font-size: 16pt; margin: 0; }
h3 { font-size: 13pt; margin: 0; }
p { margin: 0; }
ul, ol { margin: 0; padding-left: 36pt; }
table { border-collapse: collapse; width: 100%; margin: 0; }
td, th { border: 1px solid #000; padding: 4px 6px; vertical-align: top; }
hr { border: 0; border-top: 1px solid #000; margin: 0; }
img { max-width: 100%; max-height: 220mm; object-fit: contain; }
.room-details, .seal { break-inside: avoid; }
`.trim();

export const FONT_FAMILIES = ['Arial', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New', 'Open Sans'];
export const FONT_SIZES = [8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28, 32, 36];
export const DEFAULT_FONT = 'Open Sans';
export const DEFAULT_SIZE = 12;

export const cssFamily = (name) => `${/\s/.test(name) ? `'${name}'` : name}, 'Open Sans', Arial, sans-serif`;
export const normFamily = (raw) => {
  const n = String(raw || '').replace(/["']/g, '').split(',')[0].trim().toLowerCase();
  return FONT_FAMILIES.find((f) => f.toLowerCase() === n) || null;
};
export const normSize = (raw) => {
  const m = /^(\d+(?:\.\d+)?)pt$/i.exec(String(raw || '').trim());
  if (!m) return null;
  const v = parseFloat(m[1]);
  return v >= 6 && v <= 96 ? `${v}pt` : null;
};

export const PAGE_TOP_MM=54;
export const PAGE_BOTTOM_MM=6;
